// Module
var code = "<div class=\"col-xs-4\"> <label class=\"control-label\">User</label> <div class=\"form-control-static\"> {{::ctrl.item.objectDetail.DisplayName}} </div> </div> ";
// Exports
export default code;